/**
 * Basically a standard form that is used when posting and sending via client dashboard.
 * Only posting via email seems to have a vastly different layout.
 */

import React from "react";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Controller, useFormContext } from "react-hook-form";
import { FormCheck, FormSelect, FormTextArea } from "../../../forms";
import { AllCommunicationStoppedWarningMessage, NoEmailsAvailableWarningMessage } from "./WarningMessages";
import { useClientPreferencesSummary } from "../../../../hooks/ClientPreferencesSummaryContext";
import { DefReactSelectOption } from "../../../../types/DefReactSelectOption";
import { ClientReportType } from "../../../../types/ClientReportType";
import { MasterAccountSummaryContactDetailsType } from "../../../../types/MasterAccountContactDetailTypes";

// TODO: re-add the 'notify via dashboard' options as we don't have the mobile app notifications bit setup yet!

export const StandardSendForm = ({ report } : Readonly<{ report: ClientReportType }>) => {
    const [formAnimator] = useAutoAnimate();
    const { control, setValue, watch } = useFormContext();
    const { emailAddressOptions, hasEmails, preferences } = useClientPreferencesSummary();
    const isNotifiedViaDashboard = watch('isNotifiedViaDashboard');
    const isNotifiedViaEmail = watch('isNotifiedViaEmail');
    const isCustomMessageShown = isNotifiedViaDashboard || isNotifiedViaEmail;

    if (preferences?.communication.isAllCommunicationsStopped) {
        return <AllCommunicationStoppedWarningMessage />
    }

    return (
        <div className="card">
            <div className="card-body">
                <div ref={formAnimator} className="row gy-2">
                    {/*<div className="col-12">*/}
                    {/*    <Controller*/}
                    {/*        name="isNotifiedViaEmail"*/}
                    {/*        control={control}*/}
                    {/*        render={({ field: { ref, value, onChange, ...rest } }) => (*/}
                    {/*            <FormCheck */}
                    {/*                label="Notify Client via Email:"*/}
                    {/*                labelFirst={true}*/}
                    {/*                disabled={!preferences?.communication.isEmailNotificationsEnabled || !hasEmails}*/}
                    {/*                disableAnimations={true}*/}
                    {/*                isChecked={value}*/}
                    {/*                onChange={(e: boolean) => setValue('isNotifiedViaEmail', e, { shouldDirty: true })}*/}
                    {/*            />*/}
                    {/*        )}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {/* <div className="col-12">
                        <Controller
                            name="isNotifiedViaDashboard"
                            control={control}
                            render={({ field: { ref, value, onChange, ...rest } }) => (
                                <FormCheck 
                                    label="Notify Client via Online Dashboard:"
                                    labelFirst={true}
                                    disabled={!preferences?.communication.isDashboardEnabled}
                                    disableAnimations={true}
                                    isChecked={value}
                                    onChange={(e: boolean) => setValue('isNotifiedViaDashboard', e, { shouldDirty: true })}
                                />
                            )}
                        />
                    </div> */}
                    {isNotifiedViaEmail && (
                        <div className="col-12">
                            <Controller
                                name="emailAddressesToNotify"
                                control={control}
                                render={({ field: { ref, value, onChange, ...rest } }) => (
                                    <FormSelect
                                        label="Emails to Notify"
                                        helpText="A list of email addresses that will receive the notification email that the report is available."
                                        defaultValue={value}
                                        disableAnimations={true}
                                        isMulti={true}
                                        options={emailAddressOptions}
                                        onChange={(rec : DefReactSelectOption<MasterAccountSummaryContactDetailsType>[]) => setValue('emailAddressesToNotify', rec.map(e => e.value), { shouldDirty: true })}
                                        {...rest}
                                    />
                                )}
                            />
                        </div>
                    )}
                    {isCustomMessageShown && (
                        <div className="col-12">
                            <Controller
                                name="adviserMessage"
                                control={control}
                                render={({ field: { ref, value, onChange, ...rest } }) => (
                                    <FormTextArea
                                        label="Adviser Message"
                                        placeholder="Message..."
                                        helpText="Enter a custom message that will be included within the email body and/or dashboard message."
                                        value={value}
                                        minRows={6}
                                        maxRows={9}
                                        onChange={(e: any) => setValue('adviserMessage', e.target.value, { shouldDirty: true })}
                                    />
                                )}
                            />
                        </div>
                    )}
                    {isNotifiedViaEmail && !hasEmails && (
                        <NoEmailsAvailableWarningMessage />
                    )}
                </div>
            </div>
        </div>
    );
};